<template>
  <div class="bg-background-light border-b border-bw-grey">
    <div class="pt-12 pb-28 flex flex-col items-center">
      <!-- FAQ Title Section -->
      <div class="container flex flex-col py-12">
        <div class="responsive-title-2 font-bold mb-4">FAQ</div>
        <div class="responsive-body-medium ">
          {{ $t('faqsList.subtitle') }}
        </div>
      </div>

      <!-- FAQ Content -->
      <div class="container w-full space-y-10">
        <div
            v-for="(faqGroup, index) in faqsGrouped"
            :key="index"
            class="faq-item faq-question"
        >
          <!-- FAQ Group Title -->
          <div class="flex flex-col justify-between">
            <h2 class="responsive-title-5 font-bold text-left">
              {{ faqGroup.title }}
            </h2>
            <div class="faq-answer">
              <div
                  v-for="(item, qIndex) in faqGroup.questions"
                  :key="qIndex"
                  class="border-b border-gray-300 py-4"
              >
                <button
                    @click="toggleQuestion(index, qIndex)"
                    class="w-full flex justify-between items-center text-left"
                >
                  <div class="responsive-body-large text-gray-800 w-[80%]">{{ item.question }}</div>
                  <span
                      :class="{ 'chevron': true, 'open': item.open }"
                  >
                    <img src="@/assets/icons/svg/chevron.svg" alt="Chevron" />
                  </span>
                </button>
                <div v-if="item.open" class="faq-answer py-2 text-gray-600 responsive-body-medium">
                  {{ item.answer }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { ref, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

const faqsHelper = [
  ['booking', 3],
  ['paymentCosts', 3],
  ['yachtTypes', 3],
  ['destinations', 3],
  ['onboardFacilities', 3],
  ['packingPreparation', 3],
  ['activitiesWaterToys', 3],
  ['safetyRegulations', 3],
  ['paymentCancellation', 3],
  ['additionalServices', 3],
  ['yachtFeaturesCustomization', 2],
  ['healthMedicalAccessibility', 3],
  ['activitiesSpecializedExperiences', 3],
  ['foodBeverageCatering', 3],
  ['safetyNavigationInsurance', 3],
  ['additionalServicesOnshoreAssistance', 3],
  ['environmentalSustainablePractices', 2],
  ['checkInCheckOutCharterLogistics', 3],
  ['yachtMaintenanceTechnicalSupport', 2],
  ['customerSupportFeedback', 3],
];

const faqsGrouped = ref([]);

onMounted(() => {
  faqsHelper.forEach((item) => {
    const questions = [];
    for (let i = 0; i < item[1]; i++) {
      questions.push({
        question: t(`faqsList.${item[0]}.Q${i + 1}`),
        answer: t(`faqsList.${item[0]}.A${i + 1}`),
        open: false,
      });
    }
    faqsGrouped.value.push({
      title: t(`faqsList.${item[0]}.${item[0]}Res`),
      questions,
      open: false,
    });
  });
});

const toggle = (index) => {
  faqsGrouped.value[index].open = !faqsGrouped.value[index].open;
};

const toggleQuestion = (groupIndex, qIndex) => {
  faqsGrouped.value[groupIndex].questions[qIndex].open =
      !faqsGrouped.value[groupIndex].questions[qIndex].open;
};
</script>

<style scoped>
.faq-question {
  width: 100%;
  cursor: pointer;
  padding: 10px 0;
}

.faq-answer {
  padding: 10px 0;
  font-size: 16px;
  color: #8c8b94;
}

.chevron {
  transition: transform 0.3s ease;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  border: 1px solid #8c8b94;
  transform: rotate(-90deg);
}

.chevron.open {
  transform: rotate(90deg);
}

</style>